import './simple-circle';
import './simple-rect';
import './image';